import gql from 'graphql-tag';

export const deleteTargetTimeRule = gql`
  mutation deleteTargetTimeRule($input: InputDeleteTargetTimeRule!) {
    deleteTargetTimeRule(input: $input)
  }
`;
